import { ImageElement } from '@kontent-ai/gatsby-components';
import tw, { styled } from 'twin.macro';

export const StyledInfoContainer = styled('div', {
  shouldForwardProp: (propName) => propName !== 'direction',
})<{
  direction: Queries.kontent_item_n5050_block_image_and_text_row_elements_image_direction_enum;
  backgroundValue:
    | Queries.kontent_item_n5050_block_image_and_text_row_elements_background_color_enum
    | undefined;
}>`
  ${tw`md:col-span-6`}
  ${tw`py-4`}
  ${tw`flex flex-col justify-center`};
  ${({ direction }) =>
    direction === 'left' ? tw`md:col-start-7 px-[18px] lg:pr-4` : tw`px-[18px] lg:pl-4`}

  ${({ backgroundValue }) => !backgroundValue && tw`container`}
`;

export const StyledImageContainer = styled('div', {
  shouldForwardProp: (propName) => propName !== 'direction',
})<{
  direction: Queries.kontent_item_n5050_block_image_and_text_row_elements_image_direction_enum;
}>`
  ${tw`order-first`}
  ${tw`md:col-span-6`}
  ${tw`flex items-center`}
  ${tw`lg:mb-0`}
  ${tw`p-[18px] lg:py-4`}
  ${({ direction }) => (direction === 'left' ? tw`md:col-start-1` : tw`md:col-start-7`)}
`;

export const StyledImageElement = styled(ImageElement)`
  ${tw`rounded-lg`}
  ${tw`max-h-[500px] lg:max-h-full`}
  ${tw`object-contain`}

  img {
    ${tw`!object-contain`}
  }
`;
